export const getAppSearchDetails = `query GetAppSearchDetails($application: String!, $role: String) {
    getAppSearchDetails(application: $application, role: $role) {
      id
      application
      pool
      clientId
      environment
      clients {
        id
        emplid
        idmuid
        nameN
        createdDate
        active
        role
        source
      }
    }
    }`;
